module.exports = __webpack_public_path__ + "img/quest_selector_passed.93fb0837.png";